/**
 * 规则策略：把规则集包装为 DispatchStrategy（设计文档 3.5）。
 *
 * 命中规则的呼叫按规则动作分配；未命中的呼叫走兜底（最近轿厢响应），
 * 保证任何呼叫都能得到分配，避免规则漏判导致停摆。
 */
import type { Assignment, DispatchStrategy, InitContext, SnapshotView } from '../strategy-api';
import type { KinematicsParams } from '../../core/physics/kinematics';
import type { Rule } from './rule-model';
import { interpret } from './interpreter';
import { createFallbackStrategy } from '../fallback';

export function createRuleStrategy(rules: readonly Rule[], id = 'rule-engine'): DispatchStrategy {
  let kin: KinematicsParams | undefined;
  const fallback = createFallbackStrategy();
  return {
    id,
    init(ctx: InitContext) {
      kin = ctx.kinematics;
      fallback.init?.(ctx);
    },
    allocate(view: SnapshotView): Assignment[] {
      const k = kin!;
      const { assignments, matchedCallIds } = interpret(view, rules, k);
      const unmatched = view.calls.filter((c) => !matchedCallIds.has(c.id));
      if (unmatched.length > 0) {
        const fb = fallback.allocate({ ...view, calls: unmatched });
        return [...assignments, ...fb];
      }
      return assignments;
    },
  };
}
